module.exports = __webpack_public_path__ + "static/media/weatherchannel.9333cbc9.png";